import { DateObject } from "./types";

export const getPreviousMonth = (year: number, month: number): [number, number] => {
  if (month === 1) return [year - 1, 12];
  return [year, month - 1];
};

export const getNextMonth = (year: number, month: number): [number, number] => {
  if (month === 12) return [year + 1, 1];
  return [year, month + 1];
};

export const getMonthString = (year: number, month: number) => {
  const stringYear = `${year}`.padStart(4, "0");
  const stringMonth = `${month}`.padStart(2, "0");
  return `${stringYear}-${stringMonth}`;
};

export const getDaysInMonth = (year: number, month: number) => {
  return new Date(year, month, 0).getDate();
};

export const getMonthOffset = (year: number, month: number) => {
  const offset = new Date(year, month - 1, 1).getDay();
  // sunday is 6, monday is 0 (for france at least)
  return offset === 0 ? 6 : offset - 1;
};

export const dateObjectToString = ({ year, month, day }: DateObject) => {
  const stringYear = `${year}`.padStart(4, "0");
  const stringMonth = `${month}`.padStart(2, "0");
  const stringDay = `${day}`.padStart(2, "0");
  return `${stringYear}-${stringMonth}-${stringDay}`;
};

export const getTodayString = () => {
  const today = new Date();
  return dateObjectToString({
    year: today.getFullYear(),
    month: today.getMonth() + 1,
    day: today.getDate(),
  });
};

export const computeCalendarDays = (year: number, month: number) => {
  const [prevYear, prevMonth] = getPreviousMonth(year, month);
  const [nextYear, nextMonth] = getNextMonth(year, month);

  // compute amount of days in prev, current and next months
  const daysInPreviousMonth = getDaysInMonth(prevYear, prevMonth);
  const daysInCurrentMonth = getDaysInMonth(year, month);

  // compute current month offset
  const currentMonthOffset = getMonthOffset(year, month);

  const weeks: DateObject[][] = [];

  let position = -currentMonthOffset;
  let week: DateObject[] = [];

  // keep computing days until we reach the end of the month AND the last row is completely filled
  while (weeks.length < 6) {
    // handle previous month days
    if (position < 0)
      week.push({ year: prevYear, month: prevMonth, day: daysInPreviousMonth + position + 1 });
    // handle current month days
    else if (position < daysInCurrentMonth)
      week.push({ year: year, month: month, day: position + 1 });
    // fill remaining days (in last row) with next month days
    else week.push({ year: nextYear, month: nextMonth, day: position - daysInCurrentMonth + 1 });

    // if the week is full, push it to the weeks array
    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }

    // increment position
    position += 1;
  }

  return weeks;
};
